export const SELECTED_DATA_OPTIONS = {
  TIME_INTERVAL_ALL: 'all',
  TIME_INTERVAL_LAST_DAY: 'last',
  ACTIVE_STATUS_CONFIRMED: 'confirmed',
  ACTIVE_STATUS_DEATHS: 'deaths',
  ACTIVE_STATUS_RECOVERED: 'recovered',
  SIZE_STATUS_ALL: 'all',
  SIZE_STATUS_100k: '100k',
}
